<div *ngIf="agendaItem.supplementaryData?.itemDescription"
     [froalaView]="agendaItem.supplementaryData?.itemDescription">
</div>

<div *ngIf="agendaItem.componentSelector"
     class="alert alert-secondary my-3">
    <ng-container #container></ng-container>
</div>

<adapt-display-meeting-note *ngFor="let note of agendaNotes"
                            [note]="note"
                            [edit]="canEditMeetingItem$ | async"></adapt-display-meeting-note>
<adapt-display-action-link *ngFor="let link of agendaActionLinks"
                           [showDeleteLink]="canEditMeetingItem$ | async"
                           [link]="link"></adapt-display-action-link>
<adapt-display-meeting-objective-link *ngFor="let link of agendaObjectiveLinks"
                                      [showDeleteLink]="canEditMeetingItem$ | async"
                                      [link]="link"></adapt-display-meeting-objective-link>
<div class="d-flex pt-1 align-items-center justify-content-end"
     data-tour="agenda-action-items"
     *ngIf="canEditMeetingItem$ | async">
    <adapt-agenda-item-action-menu *ngIf="canEditAgendaItem"
                                   class="me-auto"
                                   data-tour="edit-agenda-item-menu"
                                   [agendaItem]="agendaItem"
                                   [hideAddActions]="true"
                                   [hideEditAgendaItem]="false"></adapt-agenda-item-action-menu>
    <ng-container *ngIf="!agendaItem.extensions.isFacilitationNotes && !agendaItem.extensions.isPreWork">
        <button class="btn btn-primary btn-pill btn-minute"
                data-tour="add-agenda-decision"
                data-test="add-agenda-decision"
                adaptTooltip="Add decision"
                (click)="addDecision()"><i [ngClass]="MeetingNoteIconClass[MeetingNoteType.Decision]"></i></button>
        <button class="btn btn-primary btn-pill btn-minute mx-1"
                data-tour="add-agenda-minute"
                data-test="add-agenda-minute"
                adaptTooltip="Add minute"
                (click)="addMinute()"><i [ngClass]="MeetingNoteIconClass[MeetingNoteType.Minute]"></i></button>
        <button class="btn btn-primary btn-pill btn-minute"
                data-tour="add-agenda-work-item"
                data-test="add-agenda-work-item"
                adaptTooltip="Add action"
                *ngIf="hasEditableBoard"
                (click)="addMeetingItem()"><i [ngClass]="MeetingItemIconClass"></i></button>
    </ng-container>
</div>
